import type { PropsWithChildren } from 'react';
import React from 'react';

import { Provider } from 'mobx-react';

import type FormStore from 'tm3-core/controls/forms/form-store';

export const FormContext = React.createContext({});

FormContext.displayName = 'BzCoreControls-FormContext';

export interface IProps<T extends FormStore<U>, U = any> extends PropsWithChildren {
  store: T;
  className?: string;
  wrapInForm?: boolean;
}

export class Form<T extends FormStore<U>, U = any> extends React.Component<IProps<T, U>> {
  render() {
    const { className, wrapInForm = true } = this.props;
    let formContent = (
      <Provider formStore={this.props.store}>
        <FormContext.Provider value={this.props.store}>{this.props.children}</FormContext.Provider>
      </Provider>
    );
    if (!wrapInForm) {
      return formContent;
    }
    return <form className={className}>{formContent}</form>;
  }
}
